// extracted by mini-css-extract-plugin
export default {"verification-box-container":"styles__verification-box-container--ekhQY"};